module.exports = "https://static.wagwalking.com/_next/static/images/vet-group-a88bfb407695cc5dab6cd029704e6609.png";